<template>
  <div class="landingLogosWithDescSection">
    <div class="container">
      <div class="landingLogosWithDescSection__header">
        <div v-if="data.SmallTitle" class="landingLogosWithDescSection__headerTitle">
          <div class="landingLogosWithDescSection__smallTitle">
            {{ data.SmallTitle }}
          </div>
          <h2 class="landingLogosWithDescSection__title" v-if="data.Title">
            {{ data.Title }}
          </h2>
        </div>
      </div>
      <div class="landingLogosWithDescSection__swiperWrapper">
        <SwiperSlider
          v-if="data.Items"
          ref="swiper"
          class="landingLogosWithDescSection__swiper"
          :options="swiperOptions"
        >
          <div
            v-for="(item, index) in data.Items"
            :key="index"
            class="landingLogosWithDescSection__slide swiper-slide"
          >
            <div class="landingLogosWithDescSection__item">
              <div class="landingLogosWithDescSection__itemImage">
                <new-image-box
                  v-if="item.Image"
                  :alt="item.Title ? item.Title : ''"
                  background-color="#fff"
                  :src="JSON.parse(item.Image).url"
                  :width="250"
                  :height="92"
                  image-params="w_250,h_92"
                />
              </div>
              <h3 v-if="item.Title">
                {{ item.Title }}
              </h3>
              <p v-if="item.Description">
                {{ item.Description }}
              </p>
            </div>
          </div>
          <div slot="pagination" class="swiper-pagination" />
        </SwiperSlider>
        <div class="landingLogosWithDescSection__navigation swiper-navigation">
          <SliderButton position="prev" @click="prevEl" :disabled="prevDisable" />
          <SliderButton position="next" @click="nextEl" :disabled="nextDisable" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VButton from '@/components/VButton.vue';
import SwiperSlider from '@/components/SwiperSlider.vue';
import NewImageBox from '@/components/NewImageBox.vue';
import SliderButton from '@/components/Sliders/SliderButton.vue';

export default {
  name: 'LandingLogosWithDescSection',
  components: { SliderButton, NewImageBox, SwiperSlider, VButton },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      nextDisable: false,
      prevDisable: false,
      swiperOptions: {
        slidesPerView: 'auto',
        loop: false,
        speed: 600,
        spaceBetween: 0,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.swiper.swiper !== 'undefined') {
        return this.$refs.swiper.swiper;
      }
      return false;
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.checkArrows();
      });

      this.swiper.once('update', () => {
        this.swiper.on('slideChange', () => {
          this.checkArrows();
        });
      });

      this.checkArrows();
    }
  },
  methods: {
    refreshSlider() {
      this.swiper.update();
      this.checkArrows();
    },
    checkArrows() {
      this.nextDisable = this.swiper.isEnd;
      this.prevDisable = this.swiper.activeIndex === 0;
    },
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.landingLogosWithDescSection {
  background: $cWhite;
  overflow: hidden;

  &__smallTitle {
    font-size: 1.8rem;
    line-height: 1.5;
    color: $cAddDark02;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  &__title {
    font-size: 4rem;
    line-height: 1.15;
    font-weight: 600;
    max-width: 50rem;
    margin-bottom: 2rem;

    b,
    strong {
      color: $cSec;
      font-weight: 600;
    }

    @include rwd('tablet') {
      font-size: 4rem;
      max-width: 100%;
    }

    @include rwd('small-tablet') {
      font-size: 2.8rem;
    }
  }

  &__swiperWrapper {
    position: relative;
  }

  &__swiper {
    position: relative;
    padding-bottom: 4rem;
    margin: 4rem -0.8rem 0;

    @include rwd('large-tablet') {
      overflow: visible;
    }

    @include rwd('tablet') {
      margin-top: 2.5rem;
    }
  }

  &__slide {
    max-width: 25%;
    height: auto;
    padding: 0 0.8rem;

    @include rwd('small-laptop') {
      max-width: 33.333%;
    }

    @include rwd('tablet') {
      max-width: 50%;
    }

    @include rwd('large-phone') {
      max-width: 100%;
    }
  }

  &__item {
    border: 1px solid $cAddLight;
    border-radius: 5px;
    height: 100%;
    padding: 3rem 3rem 5rem 3rem;

    @include rwd('tablet') {
      padding: 2rem 2rem 3rem 2rem;
    }

    h3 {
      font-size: 2.2rem;
      line-height: 1.45;
      font-weight: 700;
      margin-bottom: 1.2rem;
    }

    p {
      color: $cAddDark02;
      font-size: 1.6rem;
      line-height: 1.5;
    }
  }

  &__itemImage {
    height: 9.2rem;
    margin-bottom: 3rem;

    ::v-deep img {
      max-width: 100%;
      max-height: 100%;
      height: 100%;
    }
  }
}
</style>
